

























import { DynamicDocumentItem, InstallationModuleData, Material } from "@/types";

import Vue, { PropType } from "vue";

export default Vue.extend({
  props: {
    item: Object as PropType<DynamicDocumentItem>,
    moduleData: Object as PropType<InstallationModuleData>
  },

  computed: {
    panels(): Material[] {
      return this.$store.state.materials.panels.items;
    }
  }
});
